import SemanticFooter from "./SemanticFooter";
export default SemanticFooter;